<template>
  <button class="btn btn-outline-success" v-on="$listeners">
    <i class="icon-database-add mr-2"></i> <slot />
  </button>
</template>

<script>
export default {
  name: "SaveButton"
}
</script>

<style scoped>

</style>
